import { Pipe, NgModule } from '@angular/core';
import Autolinker from 'autolinker';

import * as ɵngcc0 from '@angular/core';
class LinkyPipe {
    transform(value, options) {
        return Autolinker.link(value, options);
    }
}
LinkyPipe.ɵfac = function LinkyPipe_Factory(t) { return new (t || LinkyPipe)(); };
LinkyPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "linky", type: LinkyPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinkyPipe, [{
        type: Pipe,
        args: [{ name: 'linky' }]
    }], null, null); })();

class LinkyModule {
}
LinkyModule.ɵfac = function LinkyModule_Factory(t) { return new (t || LinkyModule)(); };
LinkyModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LinkyModule });
LinkyModule.ɵinj = ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LinkyModule, { declarations: [LinkyPipe], exports: [LinkyPipe] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinkyModule, [{
        type: NgModule,
        args: [{
                declarations: [LinkyPipe],
                exports: [LinkyPipe]
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-linky
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LinkyModule, LinkyPipe };

//# sourceMappingURL=ngx-linky.js.map